import React, { useEffect, useMemo, useState } from "react";
import FadeIn from "../../shared/ui/animations/FadeIn.jsx";
import styles from "@/widgets/aboutSection/aboutSection.module.css";
import CardsRow from "@/features/LoyaltySystemSection/ui/cardsRow/index.jsx";
import FadeInUp from "@/shared/ui/animations/FadeInUp.jsx";
import {getPromocodes} from "@/widgets/loyaltySystem/api/api.js";

export default function LoyaltySystem () {

    const [promos, setPromos] = useState([]);

    useEffect(() => {
        const fetchPromos = async () => {
            try {
                const data = await getPromocodes();
                setPromos(data.data);
            } catch (e) {
                console.error(e)
            }
        }
        fetchPromos()

    }, []);

    // 2) Делаем индекс по типу: { BIRTHDAY: {...}, FIRST: {...}, ... }
    const promosByType = useMemo(() => {
        const arr = Array.isArray(promos) ? promos : [];
        return arr.reduce((acc, p) => {
            acc[p.promoType] = p; // or push into array if multiple promos per type
            return acc;
        }, {});
    }, [promos]);


    return (
        <section className={"container-custom"}>
            <FadeInUp>
                <p className={`body section-title`}>Система лояльности</p>
            </FadeInUp>
            <div className={`row`}>
                <div className="col-lg-3"></div>
                <div className={`col`}>
                    <FadeInUp>
                        <h2>Погружайся в мир “Подземелья” </h2>
                        <h2>и получай за это награды!</h2>
                    </FadeInUp>
                </div>
            </div>

            <div className={`${styles.textWrapper}`}>
                <div className="col-lg-3 col-0"></div>
                <div className={`col-lg-6 row`}>
                    <FadeIn delay={100}>
                        <p className={`${styles.description} body col-md`}>
                            Мы ценим каждого героя, который возвращается к нам снова и снова. Наша система лояльности - это способ сказать тебе спасибо за участие, покупки и активность. Получай баллы за игры и списывай при оплате на сайте. А еще можешь использовать наши промокоды. Играй, развивайся и становись легендой “Подземелья”!
                        </p>
                    </FadeIn>
                    <FadeIn delay={100}>
                        <p className={`${styles.description} body col-md`}>
                            Скидки действуют только при самостоятельной записи на игру через сайт и распространяются на одно место. Если игрок записывает дополнительных участников, скидка на них не применяется — каждому игроку необходимо оформить запись самостоятельно.                        </p>
                    </FadeIn>
                </div>
                <div className="col-lg-3 col-0">
                    <FadeIn delay={100}>

                    </FadeIn>
                </div>
            </div>

            <CardsRow promosByType={promosByType} />

        </section>
    );
}
